"use strict";
/*
 * Created on 01 09 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * EntityAttributeByEntityConverter
 *
 * @author JMe
 */


var EntityAttributeByEntityConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(EntityAttributeByEntityConverter, _DataObjectConverter_);

  function EntityAttributeByEntityConverter() {
    _classCallCheck(this, EntityAttributeByEntityConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(EntityAttributeByEntityConverter).apply(this, arguments));
  }

  return EntityAttributeByEntityConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.EntityAttributeByEntityConverter = EntityAttributeByEntityConverter;